import { Chip } from "@narmi/design_system";
import styles from "../LoanPortalDashboard.module.css";
import type { LoanPortalApplication } from "../types";
import type { ReactLocalization } from "@fluent/react";

/** Status badge shown on an application card. */
export function StatusTag({
  l10n,
  application,
}: {
  l10n: ReactLocalization;
  application: LoanPortalApplication;
}) {
  if (application.loanPortalStatus === "submitted") {
    return (
      <div className={styles.statusTag}>
        <Chip
          label={l10n.getString("loan-portal-status-submitted", null, "Submitted")}
          hasBorder={true}
          kind="success"
        />
      </div>
    );
  }
  return (
    <div className={styles.statusTag}>
      <Chip
        label={l10n.getString("loan-portal-status-incomplete", null, "Incomplete")}
        hasBorder={true}
        kind="info"
      />
    </div>
  );
}
